import { Dispatch, ThunkAction } from '../../../../types/actions';
import { IGetState } from '../../../../types/types';
import { IComment } from '../../../../store/model/card/types/IComment';
import { joinRest } from 'app/rest/effects/chats/chat/api/joinRest';

//TODO done
/***
 * Создаем чат, комент нуден , чтоб заполнить инфу об последнем коментарии в чате
 * @param comment
 */
export const joinToChat = (
    comment: IComment,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return dispatch(joinRest(comment));
    };
    return action;
};
